import React, { useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import questionIcon from "images/question.svg"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectDimensionsDrillDown,
  makeSelectDivisions,
  makeSelectIsLoadingDimensions,
  makeSelectShowDimensionBenchmark,
} from "./selectors"
import { getDimensionsWatcher } from "./actions"

import "./index.less"

import {
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../../../utils/storage"
import { Link } from "react-router-dom"
import ResultByDimensionChart from "../../../ReChart/ResultByDimensionChart"
import { Spin } from "antd"
import {
  searchItemInTree,
  searchTree,
  truncateText,
  validate,
} from "../../../../../utils/functions"
import PopoverImpact from "../../../PopoverImpact"
import { QuestionCircleFilled } from "@ant-design/icons"
import { PageView } from "../../../../../components/Snowplow/config2"

export function WidgetResultByDimensionEngagement(props) {
  const [dimensionParent, setDimensionParent] = useState(0)
  const [dataAux, setDataAux] = useState([])

  useEffect(() => {
    initGetData().then(() => { })
  }, [props.idMeasure, props.idDivisionSelected])

  useEffect(() => {
    setDataChart();
  }, [props.dimensionsDrillDown, dimensionParent]);

  const initGetData = async () => {
    const {
      idMeasure,
      getDimensions,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
      dimensions,
    } = props
    const params = {
      dimensions,
      isHome: true,
      id_measure: idMeasure,
      division: idDivisionSelected || idDivisionParent,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    if (measureGeneral.is_engagement) {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }
    getDimensions(params)
  }

  const setDataChart = () => {
    const { dimensionsDrillDown, measureGeneral } = props
    const dataResult = []
    let result = []
    if (dimensionParent === 0) {
      result = [...dimensionsDrillDown]
    } else {
      result = searchTree([...dimensionsDrillDown], dimensionParent)
    }
    result.map((row) => {
      if (row.engagement) {
        return
      }
      let newValue = row.value
      if (!row.anonymity_check.valid) {
        newValue = 100
      }
      let newName =
        row.name === "Resultado total"
          ? measureGeneral.metric_total_label
          : row.name
      dataResult.push({
        name: newName,
        impact: row.impact,
        name_sort: truncateText(newName, 15),
        id_dimension: row.id_dimension,
        id_dimension_parent: row.id_dimension_parent,
        id: row.id,
        id_parent: row.id_parent,
        value: newValue,
        value_visible: row.value_visible,
        childs: row.childs,
        recipients: row.recipients,
        employees: row.employees,
        prev_value: row.prev_value,
        benchmark_value: row.benchmark_value,
        color: row.color,
        anonymity_check: row.anonymity_check,
      })
    })
    setDataAux(dataResult)
  }

  const renderTitle = () => {
    const {
      idMeasure,
      idDivisionSelected,
      selectedSegment,
      measureGeneral,
    } = props

    let querySegment = ""
    let queryDivision = ""
    let queryParams = ""
    if (idDivisionSelected) {
      queryDivision = `&id_division=${idDivisionSelected}`
    }
    if (measureGeneral.segments.length > 1 && selectedSegment) {
      querySegment = `&id_segment=${selectedSegment}`
    }
    if (queryDivision !== "" || querySegment !== "") {
      queryParams = `${"?home=true"}${queryDivision}${querySegment}`
    }

    const link = `/reports/measure/${idMeasure}/divisions/${idDivisionSelected ||
      "all"}/dimensions${queryParams}`
    return (
      <div className="WidgetResultByDimensionEngagement-container-chart-header-container">
        <div className="WidgetResultByDimensionEngagement-container-chart-header-container-title">
          Resultado por dimensión con impacto
          <PopoverImpact
            container={
              <QuestionCircleFilled
                style={{
                  color: "#D8D8D8",
                  verticalAlign: "baseline",
                  fontSize: "14px",
                  marginLeft: 4,
                  cursor: "pointer",
                }}
              />
            }
          />
        </div>
        <div className="WidgetResultByDimensionEngagement-container-chart-header-container-link">
          <Link
            onClick={() =>
              PageView(
                "Resultado por dimensión con impacto - Ir a análisis detallado",
                null,
                null
              )
            }
            to={link}>
            {"Ir a análisis detallado >"}
          </Link>
        </div>
      </div>
    )
  }

  const getDataChildren = (data) => {
    if (
      validate.exist(data.childs) &&
      data.childs.length > 0 &&
      data.anonymity_check.valid
    ) {
      setDimensionParent(data.id)
    }
  }

  const getBackData = (idDimensionParent) => {
    const result = searchItemInTree(
      [...props.dimensionsDrillDown],
      idDimensionParent
    )
    setDimensionParent(result.id_parent)
  }

  const renderChart = () => {
    const { measureGeneral, showDimensionBenchmark,measureTotal } = props

    return (
      <ResultByDimensionChart
        data={dataAux}
        measureGeneral={measureGeneral}
        getDataChildren={getDataChildren}
        getBackData={getBackData}
        dimensionParent={dimensionParent}
        showDimensionBenchmark={showDimensionBenchmark}
        hideImpact={measureTotal.employees<=20}
      />
    )
  }

  const renderContainer = () => {
    if (props.isLoadingDimensions) {
      return (
        <div className="WidgetResultByDimensionEngagement-container">
          <div className="WidgetResultByDimension-container-chart">
            <div className="loadingSpin">
              <Spin size="large" />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="WidgetResultByDimensionEngagement-container">
        <div className="WidgetResultByDimensionEngagement-container-chart">
          <div className="WidgetResultByDimensionEngagement-container-chart-header">
            {renderTitle()}
          </div>
          <div className="WidgetResultByDimensionEngagement-container-chart-container">
            {renderChart()}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="WidgetResultByDimensionEngagement">{renderContainer()}</div>
  )
}

WidgetResultByDimensionEngagement.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  history: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingDimensions: PropTypes.bool,
  dimensionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  divisions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getDimensions: PropTypes.func,
  showDimensionBenchmark: PropTypes.bool,
  selectedSegment: PropTypes.number,
  dimensions: PropTypes.object
}

const mapStateToProps = createStructuredSelector({
  isLoadingDimensions: makeSelectIsLoadingDimensions(),
  dimensionsDrillDown: makeSelectDimensionsDrillDown(),
  divisions: makeSelectDivisions(),
  showDimensionBenchmark: makeSelectShowDimensionBenchmark(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({
  key: "widgetResultByDimensionEngagement",
  reducer,
})
const withSaga = injectSaga({ key: "widgetResultByDimensionEngagement", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetResultByDimensionEngagement)
